(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/shared-components/products/components/card-list.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/shared-components/products/components/card-list.js');
"use strict";


const ProductCard = svs.tickets_giftshop.products.components.ProductCard;
const getCart = svs.tickets_giftshop.gift.giftform.cart.getters.getCart;
const CardList = _ref => {
  let _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    _ref$cart = _ref.cart,
    cart = _ref$cart === void 0 ? [] : _ref$cart,
    isCartFull = _ref.isCartFull;
  return products.map((p, i) => {
    const cartItem = cart.find(_ref2 => {
      let _ref2$product = _ref2.product,
        productId = _ref2$product.productId,
        productVariation = _ref2$product.productVariation,
        type = _ref2$product.type,
        skinId = _ref2$product.skinId;
      return productId === p.productId && productVariation === p.productVariation && type === p.type && p.skinId === skinId;
    }) || {};
    const productCount = cartItem.amount || 0;
    const key = "product_".concat(p.productId, "_").concat(p.productVariation, "_").concat(p.type, "_").concat(p.skinId, "_").concat(i);
    return React.createElement(ProductCard, {
      isDisabled: isCartFull,
      key: key,
      lastUpdatedFromType: cartItem.lastUpdatedFromType,
      product: p,
      productCount: productCount,
      skinId: p.skinId
    });
  });
};
const mapState = state => {
  const _getCart = getCart(state),
    cart = _getCart.cart,
    isFull = _getCart.isFull;
  return {
    cart,
    isCartFull: isFull
  };
};
svs.tickets_giftshop.products.components.CardList = ReactRedux.connect(mapState)(CardList);

 })(window);